// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"ee25334c","611":"dc0c4f0c"}[chunkId] + ".css";
};